import React from 'react';
import { connect } from 'react-redux';
import findInObject from '@wikom/find-in-object';
import PropTypes from 'prop-types';
import { showNavbar, hideNavbar } from '../actions/navbarActions';
var Navbar = function (_a) {
    var name = _a.name, children = _a.children, navbar = _a.navbar, className = _a.className, show = _a.show, hide = _a.hide, containerFluid = _a.containerFluid;
    return (React.createElement("nav", { className: className || 'navbar navbar-default' },
        React.createElement("div", { className: containerFluid ? 'container-fluid' : 'container' },
            React.createElement("div", { className: "navbar-header" },
                React.createElement("button", { type: "button", className: 'navbar-toggle' + (name === findInObject('toggled', navbar) ? '' : ' collapsed'), onClick: (name === findInObject('toggled', navbar)) ? function () { return hide(); } : function () { return show(name); } },
                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                    React.createElement("span", { className: "icon-bar" }),
                    React.createElement("span", { className: "icon-bar" }),
                    React.createElement("span", { className: "icon-bar" }))),
            React.createElement("div", { className: 'collapse navbar-collapse' + (name === findInObject('toggled', navbar) ? ' in' : '') },
                React.createElement("ul", { className: "nav navbar-nav" }, children)))));
};
Navbar.propTypes = {
    name: PropTypes.string,
};
var mapStateToProps = function (state) { return ({
    navbar: state.navbar,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    show: function (name) { return dispatch(showNavbar(name)); },
    hide: function () { return dispatch(hideNavbar()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
